import { newAxiosIns } from '@/libs/axios'

export function apiUploadImage(image, product_id) {
  const formData = new FormData()
  // Gunakan nama field yang sama untuk setiap file
  image.forEach(img => {
    formData.append('image_path', img.file)
  })
  return newAxiosIns.post(
    `komship/api/v1/product_images/${product_id}`,
    formData,
  )
}
export function apiEditImage(image, old_image_id, product_id) {
  const formData = new FormData()

  // Handle multiple images
  image.forEach(img => {
    formData.append('image_path', img.file)
  })

  // old_image_id should be a comma-separated string of IDs to replace
  formData.append('old_image_id', old_image_id)

  return newAxiosIns.put(
    `komship/api/v1/product_images/${product_id}`,
    formData,
  )
}

export function apiUploadImageTemp(image) {
  const formData = new FormData()
  formData.append('image_path', image)
  return newAxiosIns.post('komship/api/v1/product_images/tmp', formData)
}
export function apiDeleteImageTemp(image_id) {
  return newAxiosIns.delete(`komship/api/v1/product_images/tmp/${image_id}`)
}

export function apiUploadVideoTemp(video, onUploadProgress) {
  const formData = new FormData()
  formData.append('video_path', video)
  return newAxiosIns.post('komship/api/v1/product_video/tmp', formData, {
    onUploadProgress,
  })
}
export function apiDeleteVideoTemp(video_id) {
  return newAxiosIns.delete(`komship/api/v1/product_video/tmp/${video_id}`)
}
